<template>
    <div class="row mb-2 mb-md-4 sticky-lg-top">
        <div class="col-12">
            <div class="card">
                <div ref="mobileAnchor" class="mobileAnchor"></div>
                <div class="card-header text-white pb-2" :class="[{'fixedToBot': fixedToBot}, priceBgColour]">
                    <div class="d-flex align-items-center">
                        <div>
                            <div class="small">Total Price</div>
                            <b class="fs-3">£{{ updatedBasket.total ?? '0.00' }}</b>
                        </div>
                        <span @click="scrollToBottom()" class="d-block d-sm-none ms-4 btn btn-primary"
                            :class="{'d-none': !fixedToBot}">Continue</span>
                    </div>
                </div>
                <div class="card-body">
                    <div class="d-flex justify-content-between align-items-center mb-1">
                        <template v-if="tyresInBasket?.length > 0 && sizeUrl">
                            <div class="d-block small">Your selected tyres</div>
                            <div class="text-end">
                                <a :href="decodeURI(sizeUrl)" class="small text-primary" :class="linkColour"
                                    title="Change Tyres">(Change tyres)</a>
                            </div>
                        </template>
                    </div>
                    <div v-for="(product, index) in updatedBasket?.products" :key="product.st_code">
                        <div v-if="product.product_type == 'product'">
                            <div class="d-flex justify-content-between align-items-center">
                                <b>{{ product.brand }}</b>
                                <b>£{{ product.display_total }}</b>
                            </div>
                            <div class="d-flex justify-content-between align-items-center">
                                <div class="d-flex flex-column">
                                    <p class="mb-0">{{ product.tyre_range }}</p>
                                    <small class="fw-light">{{ product.description }}</small>
                                    <!-- <lifetime-guarantee></lifetime-guarantee> -->
                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="fa-solid fa-md fa-trash-can mx-2 cursor-pointer" title="Remove Tyre"
                                        @click="removeProduct(product.st_code)"></i>
                                    <select name="quantity" id="quantity" class="d-inline-block form-select float-end"
                                        @change="this.updateQuantity($event, product.st_code, true)">
                                        <option v-for="index in 5" :key="index" :value="index"
                                            :selected="index == product.quantity">{{ index }}</option>
                                    </select>
                                </div>
                            </div>
                            <hr class="my-2" v-if="index < tyresInBasket.length - 1">
                        </div>
                    </div>
                    <hr>
                    <div v-if="updatedBasket.mobile_fitting > 0"
                        class="d-flex justify-content-between align-items-center">
                        <b>Mobile Fitting amount:</b>
                        <b>£{{ updatedBasket.mobile_fitting }}</b>
                    </div>
                    <hr v-if="updatedBasket.mobile_fitting > 0">
                    <div v-if="updatedBasket.delivery_amount > 0"
                        class="d-flex justify-content-between align-items-center">
                        <b>Delivery amount:</b>
                        <b>£{{ updatedBasket.delivery_amount }}</b>
                    </div>
                    <div v-if="updatedBasket?.disposal_fee > 0">
                        <div class="d-flex align-items-center justify-content-between">
                            <b>Environmental Fee:</b>
                            <b>&pound;{{ updatedBasket.disposal_fee }}</b>
                        </div>
                        <span
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="For a small environmental disposal fee, we responsibly dispose of all waste from your car in line with government regulations. We work with registered professionals to store, collect, recycle, or safely dispose of waste, ensuring full compliance with current laws."
                        >
                            <small class="text-primary cursor-pointer text-underline">What's this?</small>
                        </span>
                    </div>
                    <div v-if="updatedBasket?.disposal_fee > 0">
                        <hr>
                    </div>
                    <div v-if="!updatedBasket.home_delivery > 0">
                        <div class="d-flex justify-content-between">
                            <div class="d-block small">Your selected fitter</div>
                            <div class="text-end" v-if="updatedBasket?.fitter_id">
                                <a href="/choose-fitter" class="small text-primary" :class="linkColour"
                                    title="Change Fitter">(Change fitter)</a>
                            </div>
                        </div>
                        <div v-if="updatedBasket?.fitter?.name">
                            <b>{{ updatedBasket.fitter.name }}</b>
                        </div>
                        <div v-if="updatedBasket?.app_date">
                            <p class="mb-0">on {{ formattedDate }}</p>
                        </div>
                        <div v-if="!updatedBasket?.fitter_id"><b>No fitter selected</b></div>
                    </div>
                    <hr v-if="servicesInBasket?.length > 0 || coverageInBasket?.length > 0">
                    <div v-for="(product, index) in coverageInBasket" :key="product.st_code">
                        <div v-if="index === 0" class="col-12 small">Your selected extras</div>
                        <div class="d-flex justify-content-between" v-if="product.product_type == 'cover'">
                            <div><i class="fa-solid fa-circle-check me-2 text-green fs-6"></i>{{ product.service_name }}
                                {{ product.description }}</div>
                            <div class="text-end">
                                <span>£{{ product.display_total }}</span>
                            </div>
                        </div>
                    </div>
                    <div v-for="(product, index) in servicesInBasket" :key="product.st_code">
                        <div class="d-flex justify-content-between" v-if="product.product_type == 'service'">
                            <div><i class="fa-solid fa-circle-check me-2 text-green fs-6"></i>{{product.service_name}}
                                {{ product.description }}</div>
                            <div class="text-end">
                                <span>£{{ product.display_total }}</span>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <marketing v-if="buttonUrl?.includes('booking-details')" :basket="updatedBasket"></marketing>
                    <a :href="buttonUrl" class="d-none d-lg-block col-12 btn btn-primary">{{ buttonText }}</a>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import dayjs from '@frontend/node_modules/dayjs';
    import basketFunctions from "@shared/mixins/basket";
    export default {
        mixins: [
            basketFunctions
        ],
        props: [
            'fitter', 
            'basket',
            'buttonUrl',
            'buttonText',
            'priceBgColour',
            'linkColour'
        ],
        inject: ['sizeUrl'],
        data() {
            return {
                updatedBasket: this.basket,
                fixedToBot: true
            }
        },
        created () {
            window.addEventListener('scroll', this.handleScroll);
        },
        unmounted () {
            window.removeEventListener('scroll', this.handleScroll);
        },
        mounted() {
            this.emitter.on('updateBasket', data => {
                this.updatedBasket = data;
            });
        },
        methods: {
            async removeProduct(st_code) {
                await this.deleteFromBasket(st_code);
            },
            elementIsVisibleInViewport(el, partiallyVisible = false) {
                var element = document.getElementsByClassName(el);

                const { top, left, bottom, right } = element[0].getBoundingClientRect();
                const { innerHeight, innerWidth } = window;
                return partiallyVisible
                    ? ((top > 0 && top < innerHeight) ||
                        (bottom > 0 && bottom < innerHeight)) &&
                        ((left > 0 && left < innerWidth) || (right > 0 && right < innerWidth))
                    : top >= 0 && left >= 0 && bottom <= innerHeight && right <= innerWidth;
            },
            handleScroll() {
                this.$nextTick(() => {
                    this.fixedToBot = !this.elementIsVisibleInViewport('mobileAnchor');
                });
            },
            scrollToBottom() {
                this.$refs.mobileAnchor.scrollIntoView({ behavior: "smooth" })
            }
        },
        computed: {
            servicesInBasket() {
                let filtered = this.updatedBasket?.products?.filter(product => product.product_type == 'service');
                return filtered;
            },
            coverageInBasket() {
                let filtered = this.updatedBasket?.products?.filter(product => product.product_type == 'cover');
                return filtered;
            },
            tyresInBasket() {
                let filtered = this.updatedBasket?.products?.filter(product => product.product_type == 'product');
                return filtered;
            },
            formattedDate() {
                if(this.updatedBasket?.app_date) {
                    var advancedFormat = require('@frontend/node_modules/dayjs/plugin/advancedFormat');
                    dayjs.extend(advancedFormat);

                    return dayjs(this.updatedBasket.app_date).format('dddd Do MMMM YYYY');
                }
            }
        }
    };
</script>

<style lang="scss" scoped>
    .card-header {
        .small {
            margin-bottom: -5px;
        }
    }
    .sticky-lg-top {
        top: 10px;
        z-index: 5;
    }
    .fixedToBot {
        @media screen and (max-width: 576px) {
            position: fixed;
            bottom: 0;
            width: 100%;
            left: 0;
        }
    }
</style>